import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

/**
 * Check if length of input is same as provided
 *
 * @param {string} length
 * @returns {ValidatorFn}
 */
export function validateLength(length: string): ValidatorFn {

    return (control: AbstractControl): { [key: string]: any } => {

        const value = control.value;

        if (value === '0' || value === 0) {
            return {'validateLength': {value: control.value}};
        }

        if (!value) {
            return null;
        }

        // Checking if length of input is same as provided length
        if (value && value.toString().length == length) {

            return null;
        }

        return {'validateLength': {value: control.value}};
    };

}


@Directive({
    selector: '[validateLength]',
    providers: [{provide: NG_VALIDATORS, useExisting: LengthValidatorDirective, multi: true}]
})
export class LengthValidatorDirective implements Validator {
    @Input() length: string;

    validate(control: AbstractControl): { [key: string]: any } {

        return validateLength(this.length)(control);
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/validators/length-validator.directive.ts